import {
  FormField,
  RadioButton,
  RadioButtonGroup,
  Select,
  SelectOption,
} from "@justworkshr/milo-form";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { SchemaType } from "./config";
import { ChangeEvent } from "react";
import { fieldErrorHandler } from "../../../forms/utils/fieldErrorHandler";

export default function FormFragment() {
  const { t } = useTranslation();
  const { errors, touched, handleBlur, setFieldValue, values, handleChange } =
    useFormikContext<SchemaType>();

  const handleBooleanChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.name, event.target.value === "true");
  };

  return (
    <>
      <FormField
        required
        name="probationPeriodDays"
        label={t("Probation Period")}
        error={fieldErrorHandler("probationPeriodDays", errors, touched)}
      >
        <Select
          name="probationPeriodDays"
          placeholder={t("Select probation period days")}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.probationPeriodDays}
        >
          <SelectOption value="0">{t("None")}</SelectOption>
          <SelectOption value="90">{t("90 days")}</SelectOption>
        </Select>
      </FormField>
      <FormField
        name="ptMealAllowance"
        required
        label={t("Will you be offering the meal allowance?")}
        error={fieldErrorHandler("ptMealAllowance", errors, touched)}
        message={t(
          "This is a customary allowance of €10 per day worked that is not mandatory."
        )}
      >
        <RadioButtonGroup
          name="ptMealAllowance"
          onChange={handleBooleanChange}
          onBlur={handleBlur}
          value={String(values.ptMealAllowance)}
        >
          <RadioButton name="no" value="false" label={t("No")} />
          <RadioButton name="yes" value="true" label={t("Yes")} />
        </RadioButtonGroup>
      </FormField>
    </>
  );
}
